import React from 'react';
import { Formik, Form } from 'formik';

import _ from 'lodash';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import { initFormValues } from '~/commons/helpers';

import FormGroup from '~/commons/components/FormGroup.jsx';
import FormHttpAlert from '~/commons/components/FormHttpAlert.jsx';
import FormHttpSaveBtn from '~/commons/components/FormHttpSaveBtn.jsx';

const defaults = {
  ThemeReportTemplateURL: null,
};

const FormUploadPDF = ({ setting }) => {
  const [res, req] = useHttpStatus();

  return (
    <Formik
      initialValues={initFormValues(defaults, setting)}
      onSubmit={async (vs, actions) => {
        const values = {
          ...vs,
        };
        console.log({ values });

        const { status } = await req({
          method: 'patch',
          url: `api/quiz/setting/${setting._id}`,
          data: values,
        });

        if (status === 'success') {
          actions.setSubmitting(false);
          actions.resetForm({ values: vs });
        }
      }}
    >
      <Form>
        <FormHttpSaveBtn
          res={res}
          className="btn-primary mb-3"
          disabled={false}
        />
        <FormHttpAlert res={res} />

        <div className="card my-3">
          <div className="card-header">{'上傳主題選需求 PDF'}</div>
          <div className="card-body">
            <FormGroup
              name="ThemeReportTemplateURL"
              as="file"
              api={'api/quiz/articles/files'}
              label="上傳主題選需求 PDF "
              fileOpts={{ accept: 'application/pdf' }}
            />

          </div>
        </div>
      </Form>
    </Formik>
  );
};

export default FormUploadPDF;
